import state from './state';
import getters from './getters';
import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';

export default {
  state,
  getters,
  mutations,
  actions,
};
